import axios from 'axios'
import { type } from 'os'
import store from '@/store'
import constantes from '@/utils/ConstantesGlobais'

const api = axios.create({
  baseURL: window.location.hostname.includes(constantes.DOMINIO_INTERNO) ? constantes.URL_INTERNA_BASE : constantes.URL_EXTERNA_BASE,
  withCredentials: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export default api
